import { useContext } from 'react';
import { IdentityContext } from '../providers/IdentityProvider';

/**
 * Access the global identity state and actions.
 *
 * Returns: { user, handle, partyCode, theme, hasHandle, isInGlob,
 *            setHandle, setPartyCode, leaveParty, setTheme, forgetMe }
 *
 * Throws if rendered outside <IdentityProvider> — this is intentional:
 * a missing provider is a programming error, not a runtime fallback.
 */
export function useIdentity() {
  const ctx = useContext(IdentityContext);
  if (ctx === null) {
    throw new Error('useIdentity must be used within an IdentityProvider');
  }
  return ctx;
}

export default useIdentity;
